import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import EntityProxy from "data/util/EntityProxy";
import PropTypes from "prop-types";
import React from "react";
import Kids from "lib/dataentry/lib/dataentryform/formitems/Kids";

export class Layoutgrid extends React.Component {
    render() {
        const {
            descriptor
        } = this.props;
        return (
            <div key={descriptor.key}>
                <table id={descriptor.id} className="control-layout-grid">
                    <tbody className={`control-layout-${descriptor.key}`}>
                        <Kids {...this.props} controlOnly={false} />
                    </tbody>
                </table>
            </div>
        );
    }
}

Layoutgrid.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes(null, false, true)),
    fluxContext: PropTypes.string.isRequired,
    activeRecord: PropTypes.instanceOf(EntityProxy).isRequired
};

export default Layoutgrid;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Layout/grid.js